export const MESSAGE_TYPE = {
  EMAIL: "email",
  TEXT: "text",
  BOTH: "both",
} as const;
